import "./styles.scss";

const imapemail = {
  header: "Imap Email",
  longDescription:
    "Imap Email integration will check incoming emails to analyse attachments which belongs to added mail box in the settings. IMAP is an email protocol via which your email account is configured in CyberFortress SBOX. It provides various benefits, the best of which is that it enables attachment analysis for any APT attack. An IMAP email credential is enough to enable this integration in any email platfrom. CyberFortress SBOX will alert admin and user when any malicious attachment found in that mail box. It also allow to create spam/phishing analysis use-case which is reported from other users also.",
  inputList: [
    {
      label: "Authority",
      value: "https://login.microsoftonline.com/cccc-xxxx-xxxx-xxx-xxxxxxxx",
    },
    {
      label: "Client Id",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Secret",
      value: "1234567890ABCD-XXXXXXXXXXXXXXXXXXXXXXXXX",
    },
    {
      label: "Secret Id",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Username",
      value: "example@example.com",
    },
    {
      label: "Password",
      value: "ExamplePassword123!",
    },
    {
      label: "Server",
      value: "outlook.office365.com",
    },
    {
      label: "Scope",
      value: "https://outlook.office365.com/.default",
    },
  ],
  prerequisitesList: [
    "This instance needs to have network access to added imap accounts.",
    "Username and password needs to be valid to have correct authentication to mailbox.",
  ],
};

const postfixemail = {
  header: "Postfix Email",
  longDescription:
    "The Postfix Email integration collaborates with CyberFortress SBOX to ensure the secure transmission of email messages via SMTP. This integration oversees the transmission processes of Postfix, an email server software, identifying potential security risks and providing a secure communication environment. CyberFortress SBOX allows for the technical monitoring of email messages, helps identify security vulnerabilities, and contributes preventively against cyber attacks.",
  inputList: [
    {
      label: "Server",
      value: "smtp.office365.com",
    },
    {
      label: "Port",
      value: "587",
    },
    {
      label: "Username",
      value: "example@example.com",
    },
    {
      label: "Password",
      value: "ExamplePassword123!",
    },
    {
      label: "Company",
      value: "Example Company",
    },
    {
      label: "Short",
      value: "Malicious Email Detected !",
    },
    {
      label: "Cirt Email",
      value: "example@example.com",
    },
  ],
  prerequisitesList: [
    "This integration requires network access to the added Postfix Email accounts.",
    "Valid username and password are necessary for correct authentication.",
  ],
};

const sharepoint = {
  header: "Sharepoint",
  longDescription:
    "The Sharepoint integration or other cloud-based storage platforms integrate with CyberFortress SBOX to enhance the security of file sharing in cloud-based environments. This integration oversees file transfer processes in cloud-based platforms, identifying potential risks and ensuring security. CyberFortress SBOX allows for the technical oversight of file sharing in cloud-based platforms, helps identify security vulnerabilities, and contributes significantly to secure file sharing.",
  inputList: [
    {
      label: "Authority",
      value: "https://login.microsoftonline.com/xxxxx-xxxxx-xxx-xxx-xxxxxxxx",
    },
    {
      label: "Client Id",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Secret",
      value: "1234567890ABCD-XXXXXXXXXXXXXXXXXXXXXXXXX",
    },
    {
      label: "Secret Id",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Drive Id",
      value: "1234567890-XXXXXXXXXXXXXXXXXXXXXXXXX",
    },
    {
      label: "Server",
      value: "documentLibrary",
    },
    {
      label: "Type",
      value: "onedrive",
    },
  ],
  prerequisitesList: [
    "This integration should have network access to SharePoint.",
    "Validly authenticated SharePoint accounts requiring authorized access.",
  ],
};

const fileshare = {
  header: "File Share",
  longDescription:
    "The File Share integration enhances the security of data used in file sharing by analyzing it through CyberFortress SBOX. This integration monitors data exchanges in file sharing processes, identifying potential risks and ensuring security. CyberFortress SBOX technically oversees file sharing, assists in identifying security vulnerabilities, and provides a secure environment for sharing files.",
  inputList: [
    {
      label: "Username*",
      value: "exampleusername<@DOMAIN>",
    },
    {
      label: "Password*",
      value: "ExamplePassword123!",
    },
    {
      label: "Type",
      value: "CIFS",
    },
    {
      label: "IP*",
      value: "192.168.1.1",
    },
    {
      label: "Path*",
      value: "/file/path",
    },
    {
      label: "Port",
      value: "445",
    },
  ],
  prerequisitesList: [
    "This integration should have access to an available and accessible file sharing service on the network.",
    "The Username, Password, File Share Type, Server Ip, Folder Path must be valid for proper authentication to the file sharing accounts.",
  ],
};

const endpoint = {
  header: "CS Falcon",
  longDescription:
    "The EDR API integration enhances the security of files flagged by endpoint detection and response systems by automatically analyzing those that are identified as malicious or suspicious. This integration is designed to work seamlessly with various EDR platforms, enabling CyberFortress SBOX to receive and analyze files that are suspected of being threats.",
  inputList: [
    {
      label: "Client ID",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Secret",
      value: "1234567890ABCD-XXXXXXXXXXXXXXXXXXXXXXXXX",
    },
  ],
  prerequisitesList: [
    "This integration requires network access to the CrowdStrike Falcon API endpoint.",
    "A valid Client ID and Secret must be provided with sufficient API scopes enabled in the Falcon console (e.g., Sample Uploads: Write, Detections: Read).",
  ],
};

const defender = {
  header: "MS Defender",
  longDescription:
    "The Microsoft Defender integration enhances the security of endpoint devices by analyzing files that Windows Defender flags as potentially malicious. Once flagged by Windows Defender, these files are automatically sent to CyberFortress SBOX for thorough analysis.",
  inputList: [
    {
      label: "Tenant ID",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "App ID",
      value: "12345678-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
    },
    {
      label: "Secret",
      value: "1234567890ABCD-XXXXXXXXXXXXXXXXXXXXXXXXX",
    },
  ],
  prerequisitesList: [
    "This integration requires network access to the Microsoft Defender for Endpoint API.",
    "An Azure AD application registration is required with valid Tenant ID, App ID, and Secret. The application must be granted the WindowsDefenderATP permissions in the Azure portal.",
  ],
};

const usbtransfer = {
  header: "USB Data Transfer",
  longDescription:
    "The USB Data Transfer integration allows for the detection of malware by tracking USB flash drive activities. By monitoring data transfers to and from USB flash drives, it identifies potential threats and provides an early warning system against cyber attacks. CyberFortress SBOX technically monitors USB data transfers and offers a proactive security measure against cyber threats. The USB Data Transfer integration is an effective security solution for identifying vulnerabilities and taking preventive measures against cyber threats.",
  inputList: [],
  prerequisitesList: [
    "The CyberFortress SBOX agent must be installed and running on the endpoint machines whose USB activity will be monitored.",
    "USB monitoring policy must be enabled in the SBOX management console before this integration becomes active.",
  ],
};

const proxy = {
  header: "Proxy",
  longDescription:
    "The ICAP Proxy integration helps in detecting potential threats within inbound and outbound data by analyzing them through CyberFortress SBOX. By scrutinizing files, content, and data flow during transmission, it identifies malicious software, harmful links, or other security threats, providing an early warning system against cyber attacks. CyberFortress SBOX technically monitors data traffic and offers a proactive security measure against cyber threats. The ICAP Proxy integration is an effective security solution for identifying vulnerabilities and taking preventive measures against cyber threats.",
  inputList: [
    {
      label: "Server",
      value: "smtp.office365.com",
    },
    {
      label: "Port",
      value: "587",
    },
    {
      label: "Username",
      value: "example@example.com",
    },
    {
      label: "Password",
      value: "ExamplePassword123!",
    },
    {
      label: "Company",
      value: "Example Company",
    },
    {
      label: "Short",
      value: "Malicious Email Detected !",
    },
    {
      label: "Cirt Email",
      value: "example@example.com",
    },
  ],
  prerequisitesList: [
    "This integration should have access to a server where ICAP Proxy is active on the network.",
    "The proxy server must be configured to forward ICAP requests to the CyberFortress SBOX ICAP listener on the designated port.",
  ],
  exampleConfiguration: [
    {
      label: "ICAP Service URL",
      value: "icap://<CYBERFORTRESS_IP>:13344/squidclamav",
    },
    {
      label: "Port",
      value: "13344",
    },
    {
      label: "Service Name",
      value: "squidclamav",
    },
    {
      label: "Supported Methods",
      value: "REQMOD, RESPMOD",
    },
  ],
};

const tap = {
  header: "Tap Interface",
  longDescription:
    "The TAP Interface integration allows for the analysis of network traffic through CyberFortress SBOX. By scrutinizing data flow during transmission, it identifies malicious software or other security threats, providing an early warning system against cyber attacks. CyberFortress SBOX technically monitors data traffic and offers a proactive security measure against cyber threats. The TAP Interface integration is an effective security solution for identifying zero day attacks and taking preventive measures against cyber threats.",
  inputList: [
    {
      label: "Interface",
      value: "eth1",
    },
    {
      label: "Type",
      value: "tap",
    },
  ],
  prerequisitesList: [
    "This integration should have an active TAP-configured interface on the CyberFortress SBOX application server. You can set it via the SBOX CLI command: settapinterface <interface_name> in config mode.",
    "The TAP interface must be connected to a network switch or hardware TAP device that mirrors the target traffic.",
  ],
};

const broadcomcas = {
  header: "Broadcom Content Analysis (CAS)",
  longDescription:
    "The Broadcom Content Analysis System (CAS), formerly known as Symantec CAS, enables security teams to extend file analysis capabilities by forwarding suspicious content to CyberFortress SBOX. Using the CyberFortress SBOX API key within the Broadcom CAS integration panel, detected files and attachments are automatically submitted for in-depth sandboxing and threat analysis. This integration strengthens your existing Broadcom security infrastructure by adding CyberFortress SBOX as an external analysis engine, ensuring comprehensive coverage against evolving malware threats.",
  inputList: [],
  prerequisitesList: [
    "An active Broadcom Content Analysis System deployment with external sandbox integration support is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into Broadcom CAS's external sandbox or FireEye AX configuration settings. Broadcom CAS will then automatically submit suspicious files to CyberFortress SBOX for analysis.",
  ],
};

const googlesecopss = {
  header: "Google Security Operations",
  longDescription:
    "The Google Security Operations integration, formerly known as Chronicle, connects CyberFortress SBOX with Google's cloud-native SIEM and SOAR platform. By configuring the CyberFortress SBOX API key within Google Security Operations' integration or playbook settings, security analysts can trigger automated sample submissions to CyberFortress SBOX directly from investigation workflows and SOAR playbooks. This integration enriches threat intelligence within Google Security Operations by providing detailed sandbox analysis results, helping SOC teams respond faster and more accurately to potential threats.",
  inputList: [],
  prerequisitesList: [
    "An active Google Security Operations (Chronicle) instance with SOAR playbook or integration configuration access is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into Google Security Operations' FireEye AX sandbox integration or playbook configuration. Google Security Operations will then automatically submit suspicious samples to CyberFortress SBOX as part of your investigation workflows.",
  ],
};

const cortexsoar = {
  header: "Cortex XSOAR",
  longDescription:
    "The Cortex XSOAR integration, formerly known as Demisto, allows security orchestration and automation teams to incorporate CyberFortress SBOX as a sandboxing and file analysis engine within their SOAR playbooks. By entering the CyberFortress SBOX API key in the Cortex XSOAR integration configuration, analysts can automatically submit suspicious files and indicators encountered during incident response workflows to CyberFortress SBOX for deep inspection. This integration accelerates incident response times by embedding automated malware analysis directly into Cortex XSOAR's orchestration pipelines.",
  inputList: [],
  prerequisitesList: [
    "An active Cortex XSOAR instance with integration configuration permissions is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into the FireEye AX integration settings within Cortex XSOAR. Cortex XSOAR playbooks will then automatically submit suspicious samples to CyberFortress SBOX during incident investigation and response.",
  ],
};

const sumologic = {
  header: "Sumo Logic",
  longDescription:
    "The Sumo Logic integration connects CyberFortress SBOX with Sumo Logic's cloud-native security analytics and log management platform. By configuring the CyberFortress SBOX API key within Sumo Logic's integration or automation settings, security teams can forward suspicious files and artifacts identified during log analysis and threat investigations to CyberFortress SBOX for sandbox analysis. Analysis results are then surfaced back within Sumo Logic's security dashboards, enabling enriched threat visibility and faster decision-making across your security operations.",
  inputList: [],
  prerequisitesList: [
    "An active Sumo Logic instance with Cloud SIEM or automation integration access is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into Sumo Logic's FireEye AX sandbox integration or automation settings. Sumo Logic will then automatically submit suspicious samples to CyberFortress SBOX and incorporate the enriched analysis results into your security dashboards.",
  ],
};

const opswatmetadefender = {
  header: "OPSWAT MetaDefender NDR",
  longDescription:
    "The OPSWAT MetaDefender NDR integration enables network detection and response teams to extend file and content analysis by forwarding suspicious network artifacts to CyberFortress SBOX. By entering the CyberFortress SBOX API key within the OPSWAT MetaDefender NDR integration settings, detected files and payloads extracted from network traffic are automatically submitted for in-depth sandboxing. This integration strengthens network-layer threat detection by combining MetaDefender's NDR capabilities with CyberFortress SBOX's advanced malware analysis engine.",
  inputList: [],
  prerequisitesList: [
    "An active OPSWAT MetaDefender NDR deployment with external sandbox or FireEye AX integration support is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into OPSWAT MetaDefender NDR's FireEye AX sandbox configuration. MetaDefender NDR will then automatically forward suspicious network artifacts and files to CyberFortress SBOX for analysis.",
  ],
};

const threatq = {
  header: "ThreatQ Platform",
  longDescription:
    "The ThreatQ Platform integration connects CyberFortress SBOX with ThreatQ's threat intelligence management platform. By configuring the CyberFortress SBOX API key within ThreatQ's integration settings, threat intelligence analysts can automatically submit suspicious files, URLs, and indicators of compromise (IOCs) encountered during threat research to CyberFortress SBOX for sandbox analysis. Results from CyberFortress SBOX are fed back into ThreatQ, enriching the threat intelligence database and supporting more informed and timely threat response decisions.",
  inputList: [],
  prerequisitesList: [
    "An active ThreatQ Platform instance with integration or source configuration access is required.",
    "Navigate to the FireEye AX integration screen within CyberFortress SBOX to generate your API key. Then enter this API key into ThreatQ's FireEye AX sandbox integration or sources panel. ThreatQ will then automatically submit suspicious samples and IOCs to CyberFortress SBOX and incorporate the analysis results into your threat intelligence workflows.",
  ],
};

const IntegrationModalContent = ({ modalType }) => {
  if (modalType === "imapemail") {
    return <ModalContent type={imapemail} />;
  } else if (modalType === "postfixemail") {
    return <ModalContent type={postfixemail} />;
  } else if (modalType === "rclshare") {
    return <ModalContent type={sharepoint} />;
  } else if (modalType === "winshare") {
    return <ModalContent type={fileshare} />;
  } else if (modalType === "icapweb") {
    return <ModalContent type={proxy} />;
  } else if (modalType === "tapweb") {
    return <ModalContent type={tap} />;
  } else if (modalType === "cstrike") {
    return <ModalContent type={endpoint} />;
  } else if (modalType === "defender") {
    return <ModalContent type={defender} />;
  } else if (modalType === "usbtransfer") {
    return <ModalContent type={usbtransfer} />;
  } else if (modalType === "broadcomcas") {
    return <ModalContent type={broadcomcas} />;
  } else if (modalType === "googlesecopss") {
    return <ModalContent type={googlesecopss} />;
  } else if (modalType === "cortexsoar") {
    return <ModalContent type={cortexsoar} />;
  } else if (modalType === "sumologic") {
    return <ModalContent type={sumologic} />;
  } else if (modalType === "opswatmetadefender") {
    return <ModalContent type={opswatmetadefender} />;
  } else if (modalType === "threatq") {
    return <ModalContent type={threatq} />;
  }
};

export default IntegrationModalContent;

const ModalContent = ({ type }) => {
  const { header, longDescription, inputList, prerequisitesList, exampleConfiguration } = type;
  return (
    <div className="content-container">
      <h3 className="content-container__header">{header}</h3>
      <p className="content-container__text">{longDescription}</p>
      {inputList.length > 0 ? (
        <>
          <h3 className="content-container__header">Example Data</h3>
          <div className="content-container__inputs">
            {inputList.map((input, i) => (
              <InputGroup key={i} label={input.label} value={input.value} />
            ))}
          </div>
        </>
      ) : null}
      <h3 className="content-container__header">Prerequisites</h3>
      {prerequisitesList.map((prereq, i) => (
        <p key={i} className="content-container__list-item">
          {prereq}
        </p>
      ))}
      {exampleConfiguration ? (
        <>
          <h3 className="content-container__header">Example Configuration</h3>
          <div className="content-container__configurations">
            {exampleConfiguration.map((input, i) => (
              <Configuration key={i} label={input.label} value={input.value} />
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
};

const InputGroup = ({ label, value }) => {
  return (
    <div className="integration-modal__input-group">
      <label className="integration-modal__label">{label}</label>
      <input className="integration-modal__input" value={value} readOnly />
    </div>
  );
};

const Configuration = ({ label, value }) => {
  return (
    <div className="integration-modal__configuration">
      <label className="integration-modal__configuration__label">{label}: </label>
      <p className="integration-modal__configuration__value">{value}</p>
    </div>
  );
};
